// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_9e1425b4d3--avatar--ceW9Q","clickable":"_9e1425b4d3--clickable--jjxbB","company":"_9e1425b4d3--company--MXKHY"};